import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AlertService } from '../shared/services/alert.service'


@Injectable()
export class InternalServerErrorInterceptor implements HttpInterceptor {
  constructor(private alertService: AlertService) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do((event: HttpEvent<any>) => {}, (err: any) => {
      if (err instanceof HttpErrorResponse && err.status === 500) {
        console.error(`Status ${err.status}. ${err.message}`, "Error");
        this.alertService.error("Oops! Something went wrong");
      }
    });
  }
}

@Injectable()
export class ForbiddenErrorInterceptor implements HttpInterceptor {
  constructor(private alertService: AlertService) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do((event: HttpEvent<any>) => {}, (err: any) => {
      if (err instanceof HttpErrorResponse && err.status === 403) {
        console.error(`Status ${err.status}. ${err.message}. ${err.error}.`, "Error");
        this.alertService.error(err.error);
      }
    });
  }
}

@Injectable()
export class UnprocessableEntityInterceptor implements HttpInterceptor {
  constructor(private alertService: AlertService) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do((event: HttpEvent<any>) => {}, (err: any) => {
      if (err instanceof HttpErrorResponse && err.status === 422) {
        console.error(`Status ${err.status}. ${err.message}. ${err.error}.`, "Error");
        this.alertService.error(err.error);
      }
    });
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/http/interceptors.ts